export const bmp = [
  66,
  77,
  54,
  96,
  0,
  0,
  0,
  0,
  0,
  0,
  54,
  0,
  0,
  0,
  40,
  0,
  0,
  0,
  128,
  0,
  0,
  0,
  192,
  255,
  255,
  255,
  1,
  0,
  24,
  0,
  0,
  0,
  0,
  0,
  0,
  96,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0
];
